import initReactApp from 'dpl/util/initReactApp';
import Article from 'dpl/prismic/article/components/Article';
import Preview from 'dpl/prismic/components/Preview';
import Hub from 'dpl/prismic/hub/components/Hub';
import GoodBreederCenterMobileJoinBox from 'dpl/good_breeder_center/components/MobileJoinBox';

initReactApp({
  Article,
  Preview,
  Hub,
  GoodBreederCenterMobileJoinBox
});
